var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklerTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,16)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    cx: 0,
    cy: 0,
    fill: "#fff",
    stroke: "#3e4346",
    strokeWidth: 0.64,
    style: {
      userSelect: "none"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#9EA1A2",
    r: 6.8,
    cx: 0,
    cy: 0,
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.36,
    cx: 0,
    cy: 0,
    fill: "#fff",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    stroke: "none",
    transform: "translate(3,4) scale(0.8)",
    d: "M25.71,17.38A13,13,0,0,0,13,7a12.71,12.71,0,0,0-3.68.54,13,13,0,1,0,16.42,9.86ZM13,30a10,10,0,1,1,10-10.8c0,.26,0,.53,0,.8A10,10,0,0,1,13,30Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "red",
    cx: 19.97,
    cy: 10,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8,4) scale(0.65)",
    fill: "#fff",
    d: "M19,20A10,10,0,1,1,29,10,10,10,0,0,1,19,20ZM19,1.5a8.5,8.5,0,1,0,8.5,8.5A8.51,8.51,0,0,0,19,1.5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    transform: "translate(4, 2) scale(0.85)",
    d: "M18.18,11l-.61-4.28V4H20V6.76L19.45,11Zm-.57,3.47V12.09H20V14.5Z",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklerTour);
export default __webpack_public_path__ + "static/media/sprinkler-tour.ebfea1b18887ac9327a7681070533144.svg";
export { ForwardRef as ReactComponent };